// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2_vy_","Success":"Button_Success__2E7_W","Danger":"Button_Danger__3Q2-y"};